// @flow
import types from "./types";
import type {Action} from "../DucksUtils";
import type {LatLngLiteral} from "../../../Utils/MapUtils";
import CurrentRequestTypes from "../CurrentRequest/types";

type MandatoryKeys = {|
    ready: boolean,
    center: LatLngLiteral,
|};
type OptionalKeys = {|
    isInZone?: boolean,
    latLngToPanTo?: LatLngLiteral,
    boundsToFit?: Array<LatLngLiteral>,
|};

export type MapData = { ...MandatoryKeys, ...OptionalKeys } | OptionalKeys;

export const MapDataDefault = {
    ready: false,
    center: {
        lat: 0,
        lng: 0,
    },
    latLngToPanTo: undefined,
    boundsToFit: undefined,
    isInZone: true,
};

const MapDataReducer = (mapData: MapData = MapDataDefault, action: Action): MapData => {
    const type: string = action.type;
    const payload = action.payload;
    switch (type) {
        case types.MAP_CENTER_IN_ZONE:
            return {
                ...mapData,
                isInZone: payload,
            };
        case types.MAP_LOADING_DONE:
            return {
                ...mapData,
                ready: true,
            };
        case CurrentRequestTypes.ORIGIN_SUGGESTION_SET:
        case CurrentRequestTypes.DEST_SUGGESTION_SET:
        case types.MAP_FOCUS_LATLNG:
            return {
                ...mapData,
                latLngToPanTo: payload.latlng,
            };
        case types.MAP_CENTER_UPDATE:
            return {
                ...mapData,
                center: payload,
                latLngToPanTo: undefined,
                boundsToFit: undefined,
            };
        case types.MAP_FOCUS_BOUNDS: {
            return {
                ...mapData,
                boundsToFit: payload,
            }
        }
        default:
            return mapData;
    }
};

export default MapDataReducer;



// WEBPACK FOOTER //
// ./src/Store/Ducks/MapData/reducers.js